import { isProd } from "../../util/functions";
// eslint-disable-next-line no-unused-vars
import * as Types from "./types";

const API_VERSION = "/api/v1";
const MICROSERVICE_NAME = "/memories";
const baseURL = () => {
  if (isProd) {
    return `https://memory.api.mystoriesmatter.com${API_VERSION}${MICROSERVICE_NAME}`;
  }
  return `https://qa-memory.api.mystoriesmatter.com${API_VERSION}${MICROSERVICE_NAME}`;
};

/**
 *
 * @param {Types.FetchMemoryDto} obj
 * @returns
 */
export const fetchPaginatedMemoriesUrl = (obj) => {
  return `${baseURL()}/list?pageSize=${obj.pageSize}&pageIndex=${obj.pageIndex}&orderBy=${obj.orderBy}&filterBy=${obj.filterBy ?? "me"}`;
};

export const createMemoryUrl = () => baseURL();
export const getMemoryByIdUrl = (id) => `${baseURL()}/${id}`;
export const editMemoryUrl = (id) => `${baseURL()}/${id}`;
export const deleteMemoryUrl = (id) => `${baseURL()}/${id}`;
